export default () => (JSON.parse(localStorage.getItem('user')).isStaff ? 'admin' : 'resident');
